//import cookie from 'react-cookies'
import {setUserToken} from 'actions/index.js';

const cookie = {};

class Accounts {
    constructor() {
    }

    setEthereum(ethereum) {
        this.ethereum = ethereum;
    }

    setStore(store) {
        this.store = store;
    }

    isMetamaskInstalled() {
        return false; // typeof window.web3 !== 'undefined';
    }

    async appear() {
        let account  = await this.getAccount();
        console.log("appear called = ", account);
        if (!account) {
            return;
        }
        
        fetch('/appear/' + account, {
                method: 'POST',
                headers: {
                    'Accept': 'text/html',
                    'Content-Type': 'text/html',
                },
        });
    }

    isLoggedIn() {
        return this.store &&
            this.store.getState().sequencer.userToken !== undefined;
    }

    getToken() {
        let userToken = this.store.getState().sequencer.userToken;
        return userToken ? userToken.token : undefined;
    }

    checkLogin() {
        return new Promise((resolve) => {
            // see if theres a cookie
            return resolve();
            if (window.isNFT) {
                resolve();
                return;
            }
            let token = cookie.load('token');
            if (token === '' || token === undefined) {
                resolve();
                return;
            }
            fetch('/checkToken/' + token, {
                method: 'POST',
                headers: {
                    'Accept': 'text/html',
                    'Content-Type': 'text/html',
                },
            })
                .then(async data => {
                    if (data.status === 401) {
                    } else {
                        let userName = await data.text();
                        let token = cookie.load('token');
                        this.store.dispatch(setUserToken(userName, token));
                    }
                    resolve();
                });
        });
        // verify the cookie
    }

    logout() {
        this.store.dispatch(setUserToken(undefined));
        this.account = undefined;
        console.log("logouti cookie");
        cookie.remove('token', { path: '/' })
    }

    signUp(userName, password) {
        fetch('/signUp/' + userName + '/' + password, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(data => {
            let token = cookie.load('token');
            this.store.dispatch(setUserToken(userName, token));
            this.ethereum.crypto.password = password;
        });
 
    }

    login(userName, password) {
        return new Promise((resolve, reject) => {
            fetch('/login/' + userName + '/' + password, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            }).then(data => {
                if (data.status === 401) {
                    resolve(false);
                } else {
                    let token = cookie.load('token');
                    this.store.dispatch(setUserToken(userName, token));
                    this.ethereum.crypto.password = password;
                    this.ethereum.guilds.onUserChanged();
                    this.account = undefined;
                    this.appear();
                    resolve(true);
                }
            });
        });
    }

    getAccount() {
        return new Promise(async (resolve, reject) => {
            if (this.account) {
                let acc = this.account;
                resolve(acc);
                return;
            }
            if (!this.isLoggedIn()) {
                resolve(undefined);
                return;
            }
            // get the account for the token
            fetch('/getAccount/', { 
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include'
            }).then(async data => {
                if (data.status === 401 || data.status === 404) {
                    resolve(undefined);
                } else {
                    this.account = await data.text();
                    console.log('account = ', this.account);
                    resolve(this.account);
                }
            });
        });
    }

    async getUserName() {
        if (this.isMetamaskInstalled()) {
            let userId = await this.ethereum.getUser();
            let userName = await this.ethereum.users.getUserName(userId);
            return userName;
        } else {
            if (this.isLoggedIn()) {
                return this.store.getState().sequencer.userToken.userName;
            } else {
                console.log("is not logged in...");
                return "Not Logged In";
            }
        }
    }
}

const accounts = new Accounts();

export default accounts;
